"use client";

import { ArrowRight, Minus, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Rochester() {
  const address = "44 Kerferd St";
  const cityState = "Rochester, VIC 3561, Australia";
  return <section data-section-id="3956" id="our-rochester-base" className="relative w-full bg-background text-foreground overflow-hidden" style={{
    height: "80vh",
    minHeight: "600px"
  }}>
      {}
      <div className="absolute inset-0 bg-background">
        {}
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" viewBox="0 0 1600 900">
          {}
          <rect width="1600" height="900" fill="hsl(220 20% 2%)" />

          {}
          <path d="M0,200 Q400,150 800,250 T1600,200 L1600,900 L0,900 Z" fill="hsl(220 15% 10%)" />
          <path d="M0,500 Q300,450 600,520 T1200,500 T1600,540 L1600,900 L0,900 Z" fill="hsl(220 15% 8%)" />
          <ellipse cx="400" cy="350" rx="220" ry="120" fill="hsl(220 15% 10%)" />
          <ellipse cx="1200" cy="400" rx="280" ry="140" fill="hsl(220 15% 10%)" />
          <ellipse cx="900" cy="700" rx="320" ry="100" fill="hsl(220 15% 9%)" />

          {}
          <g stroke="hsl(215 15% 55%)" strokeWidth="1" fill="none" opacity="0.85">
            <path d="M0,450 L1600,450" />
            <path d="M800,0 L800,900" />
            <path d="M0,200 Q400,300 800,450 T1600,650" />
            <path d="M200,0 Q300,400 500,900" />
            <path d="M1100,0 Q1300,400 1500,900" />
            <path d="M0,750 L1600,720" />
            <path d="M0,150 Q500,180 1000,140 T1600,180" />
            <path d="M400,0 L420,900" />
            <path d="M1180,0 L1200,900" />
          </g>

          {}
          <g stroke="hsl(215 15% 55%)" strokeWidth="0.5" fill="none" opacity="0.5">
            <path d="M0,300 L1600,310" />
            <path d="M0,600 L1600,590" />
            <path d="M600,0 L610,900" />
            <path d="M1000,0 L1010,900" />
            <path d="M0,380 Q400,400 800,380 T1600,400" />
            <path d="M0,550 Q400,570 800,550 T1600,570" />
          </g>
        </svg>

        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" style={{
          width: "160px",
          height: "160px",
          borderRadius: "0px",
          background: "radial-gradient(circle, hsl(215 15% 55% / 0.35) 0%, hsl(215 15% 55% / 0) 70%)",
          filter: "blur(8px)"
        }} />

          {}
          <span className="absolute top-1/2 left-1/2 block" style={{
          width: "60px",
          height: "60px",
          marginLeft: "-30px",
          marginTop: "-30px",
          border: "1px solid hsl(215 15% 55%)",
          borderRadius: "0px",
          animation: "zenith-radar 4s ease-out infinite"
        }} />
          <span className="absolute top-1/2 left-1/2 block" style={{
          width: "60px",
          height: "60px",
          marginLeft: "-30px",
          marginTop: "-30px",
          border: "1px solid hsl(215 15% 55%)",
          borderRadius: "0px",
          animation: "zenith-radar 4s ease-out infinite",
          animationDelay: "2s"
        }} />

          {}
          <div className="relative flex items-center justify-center" style={{
          width: "60px",
          height: "60px",
          border: "1px solid hsl(215 15% 55%)",
          borderRadius: "0px",
          animation: "zenith-pulse 4s ease-in-out infinite"
        }}>
            {}
            <div style={{
            width: "12px",
            height: "12px",
            backgroundColor: "hsl(215 15% 55%)",
            borderRadius: "0px",
            boxShadow: "0 0 12px hsl(215 15% 55% / 0.8)"
          }} />
          </div>
        </div>

        {}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: "radial-gradient(ellipse at center, transparent 40%, hsl(220 20% 2% / 0.7) 100%)"
      }} />
      </div>

      {}
      <div className="absolute top-6 left-4 sm:top-10 sm:left-10 z-10" style={{
      width: "min(320px, calc(100% - 2rem))"
    }}>
        <div className="bg-background/70 backdrop-blur-2xl border border-border shadow-3xl p-7" style={{
        borderRadius: "0px"
      }}>
          {}
          <div className="font-mono text-xs font-medium tracking-widest text-muted-foreground uppercase mb-6">
            § 06 &mdash; CONNECT
          </div>

          {}
          <h2 className="font-default text-3xl sm:text-4xl font-bold tracking-tight text-foreground leading-[1.05] mb-6">
            THE
            <br />
            <span className="text-foreground/70">AGENCY</span>.
          </h2>

          {}
          <div className="font-default text-base text-foreground/90 leading-relaxed mb-6">
            {address}
            <br />
            {cityState}
          </div>

          {}
          <div className="h-px w-full bg-border mb-5" />

          {}
          <Link to="/ConnectPage" className="group inline-flex items-center gap-2 font-mono text-[13px] font-semibold tracking-widest uppercase text-foreground hover:text-foreground/70 transition-colors">
            GET DIRECTIONS
            <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-1" />
          </Link>

          {}
          <p className="font-default italic text-xs text-muted-foreground mt-6 leading-relaxed">
            Central hub for AI automation and digital transformation.
          </p>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 right-4 sm:bottom-10 sm:right-10 z-10 flex flex-col gap-2">
        <Button variant="ghost" size="icon" aria-label="Zoom in" className="bg-background/70 backdrop-blur-2xl border border-border text-foreground hover:bg-background/85 hover:text-foreground/70 shadow-lg size-10">
          <Plus className="size-4" />
        </Button>
        <Button variant="ghost" size="icon" aria-label="Zoom out" className="bg-background/70 backdrop-blur-2xl border border-border text-foreground hover:bg-background/85 hover:text-foreground/70 shadow-lg size-10">
          <Minus className="size-4" />
        </Button>
      </div>

      {}
      <style>{`
        @keyframes zenith-radar {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(4);
            opacity: 0;
          }
        }
        @keyframes zenith-pulse {
          0%, 100% {
            box-shadow: 0 0 0 0 hsl(215 15% 55% / 0.4);
          }
          50% {
            box-shadow: 0 0 0 8px hsl(215 15% 55% / 0);
          }
        }
      `}</style>
    </section>;
}